module.exports = __webpack_public_path__ + "img/bus-default.2ce73ea9.png";